if (!customElements.get('rg-mobile-arrivals')) {
  class RgMobileArrivals extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-mobile-arrival-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-mobile-arrival-panel]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectTab(tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
      });
    }

    selectTab(selectedTab) {
      const tabList = selectedTab.parentElement;
      const tabBounds = selectedTab.getBoundingClientRect();
      const listBounds = tabList.getBoundingClientRect();
      if (tabBounds.left < listBounds.left || tabBounds.right > listBounds.right) {
        tabList.scrollLeft += tabBounds.left - listBounds.left - (listBounds.width - tabBounds.width) / 2;
      }
      const selectedPanelId = selectedTab.getAttribute('aria-controls');

      this.tabs.forEach((tab) => {
        const isSelected = tab === selectedTab;
        tab.classList.toggle('is-active', isSelected);
        tab.setAttribute('aria-selected', String(isSelected));
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== selectedPanelId;
      });
    }

    handleKeydown(event, currentIndex) {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;

      event.preventDefault();
      let nextIndex = currentIndex;

      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      }
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (currentIndex + 1) % this.tabs.length;
      }

      this.selectTab(this.tabs[nextIndex]);
      this.tabs[nextIndex].focus();
    }
  }

  customElements.define('rg-mobile-arrivals', RgMobileArrivals);
}
